import { Button } from "@components/button/button-untitledui";
import {
	ArrowNarrowRight,
	Certificate01,
	Shield01,
	ShieldTick,
	XClose,
} from "@untitledui/icons";

type InfractionOnboardingConnectStepProps = {
	onSendCertificate: () => void;
	onContinueManual: () => void;
	onClose: () => void;
};

export function InfractionOnboardingConnectStep({
	onSendCertificate,
	onContinueManual,
	onClose,
}: InfractionOnboardingConnectStepProps) {
	return (
		<div
			className="relative flex w-full flex-col items-center px-8 pt-12 pb-8"
			data-slot="infraction-onboarding-connect-step"
		>
			<button
				aria-label="Fechar"
				className="absolute top-4 right-4 rounded-lg p-2 text-quaternary hover:bg-secondary_subtle"
				onClick={onClose}
				tabIndex={0}
				type="button"
			>
				<XClose className="size-5" />
			</button>
			<div className="mb-4 rounded-xl bg-brand-25 p-6">
				<ShieldTick aria-hidden className="size-12 text-brand-600" />
			</div>
			<h2 className="text-center font-bold text-2xl text-primary">
				Deseja conectar sua empresa agora?
			</h2>
			<p className="mt-4 max-w-lg text-center text-md text-secondary">
				Ao conectar seu certificado digital, você habilita a gestão automática e
				evita multas NIC de forma definitiva.
			</p>
			<div className="mt-10 flex w-full max-w-md flex-col gap-4">
				<button
					aria-label="Realizar envio do certificado digital"
					className="flex w-full items-center justify-between gap-4 rounded-lg bg-brand-600 p-6 text-left shadow-md transition-colors hover:bg-brand-700"
					onClick={onSendCertificate}
					tabIndex={0}
					type="button"
				>
					<div className="flex items-center gap-4">
						<div className="rounded bg-white/20 p-3">
							<Shield01 aria-hidden className="size-8 text-white" />
						</div>
						<div>
							<p className="font-bold text-md text-white">
								Realizar Envio do Certificado Digital
							</p>
							<p className="text-sm text-white/90">
								Recomendado para automação completa
							</p>
						</div>
					</div>
					<ArrowNarrowRight
						aria-hidden
						className="size-6 shrink-0 text-white"
					/>
				</button>
				<Button
					aria-label="Continuar sem conexão (cadastro manual)"
					className="w-full justify-center gap-2"
					color="secondary"
					iconLeading={Certificate01}
					onClick={onContinueManual}
					size="lg"
					tabIndex={0}
				>
					Continuar sem conexão (Cadastro Manual)
				</Button>
			</div>
		</div>
	);
}
